<template>
    <div>
        <div class="title black--text py-5">{{ $t('epdD.expectedProgeny') }}</div>
        <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="10"
                hide-default-footer
                hide-default-header
            >
            <template v-slot:header="{ props }">
                <thead class="v-data-table-header">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text" :style="{'min-width': header.width}">{{ header.text }} 
                            <v-tooltip top color="black" max-width="350" v-if="header.text!=''">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon style="margin-top: -4px;margin-left: -2px;" size="15" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span><span class="font-weight-bold">{{ header.headerTitle }}</span> {{ header.headerDef }}</span>
                            </v-tooltip>
                        </th>
                    </tr>
                </thead>
            </template>
            <template v-slot:body="{ }">
              <tbody>
                <tr
                  class=""
                >
                    <td >
                        <div class="py-3">
                            <div class="d-flex justify-space-between">
                                <span class="float-left font-weight-bold caption">Subject</span>
                                <span class="float-right font-weight-bold caption">EPD:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"> </span>
                                <span class="float-right font-weight-bold caption">+/-Chg:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"></span>
                                <span class="float-right font-weight-bold caption">Accuracy:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption">% Ranked vs Non Parent</span>
                                <span class="float-right font-weight-bold caption">% Rank:</span>
                            </div>
                        </div>
                                        
                    </td>
                    <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.birth_weight_epd !=null) ? limitDecimal(subjectEpd.birth_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.birth_weight_epd !=null) ? limitDecimal(subjectEpd.birth_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.birth_weight_epd !=null) ? limitDecimal(subjectEpd.birth_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (subjectEpd && subjectEpd.weaning_weight_epd != null ) ? limitDecimal(subjectEpd.weaning_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.weaning_weight_epd != null ) ? limitDecimal(subjectEpd.weaning_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.weaning_weight_epd != null ) ? limitDecimal(subjectEpd.weaning_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.yearling_weight_epd != null ) ? limitDecimal(subjectEpd.yearling_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.yearling_weight_epd != null ) ? limitDecimal(subjectEpd.yearling_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.yearling_weight_epd != null ) ? limitDecimal(subjectEpd.yearling_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.ribEyeArea_epd != null )  ? limitDecimal(subjectEpd.ribEyeArea_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.ribEyeArea_epd != null )  ? limitDecimal(subjectEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.ribEyeArea_epd != null ) ? limitDecimal(subjectEpd.ribEyeArea_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (subjectEpd && subjectEpd.marbling_epd != null )  ? limitDecimal(subjectEpd.marbling_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.marbling_epd != null )  ? limitDecimal(subjectEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.marbling_epd != null ) ? limitDecimal(subjectEpd.marbling_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.fatThickness_epd != null )  ? limitDecimal(subjectEpd.fatThickness_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.fatThickness_epd != null )  ? limitDecimal(subjectEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.fatThickness_epd != null ) ? limitDecimal(subjectEpd.fatThickness_rank) : '-' }}</span>
                        </td>
<!--  -->
                        <td class="text-left" >
                            <span class="caption">{{ (subjectEpd && subjectEpd.carcass_weight_epd != null )  ? limitDecimal(subjectEpd.carcass_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.carcass_weight_epd != null )  ? limitDecimal(subjectEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.carcass_weight_epd != null ) ? limitDecimal(subjectEpd.carcass_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.yield_grade_epd != null )  ? limitDecimal(subjectEpd.yield_grade_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.yield_grade_epd != null )  ? limitDecimal(subjectEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.yield_grade_epd != null ) ? limitDecimal(subjectEpd.yield_grade_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (subjectEpd && subjectEpd.milk_ability_epd != null )  ? limitDecimal(subjectEpd.milk_ability_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.milk_ability_epd != null )  ? limitDecimal(subjectEpd.milk_ability_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (subjectEpd && subjectEpd.milk_ability_epd != null ) ? limitDecimal(subjectEpd.milk_ability_rank) : '-' }}</span>
                        </td>
                    <template v-for="(h, i) in headers">
                        <td class="text-left gray2" :key="h.value" v-if="i>8">
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                        </td>
                    </template>

                </tr>
                <tr
                  class=""
                >
                    <td >
                        <div class="py-3">
                            <div class="d-flex justify-space-between">
                                <span class="float-left font-weight-bold caption">Sire</span>
                                <span class="float-right font-weight-bold caption">EPD:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"> </span>
                                <span class="float-right font-weight-bold caption">+/-Chg:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"></span>
                                <span class="float-right font-weight-bold caption">Accuracy:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption">% Ranked vs Active Sires</span>
                                <span class="float-right font-weight-bold caption">% Rank:</span>
                            </div>
                        </div>
                                        
                    </td>
                    <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.birth_weight_epd != null) ? limitDecimal(sireEpd.birth_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.birth_weight_epd != null) ? limitDecimal(sireEpd.birth_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.birth_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (sireEpd && sireEpd.weaning_weight_epd != null) ? limitDecimal(sireEpd.weaning_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.weaning_weight_epd != null) ? limitDecimal(sireEpd.weaning_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.weaning_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.yearling_weight_epd != null) ? limitDecimal(sireEpd.yearling_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yearling_weight_epd != null) ? limitDecimal(sireEpd.yearling_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.yearling_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.ribEyeArea_epd != null)  ? limitDecimal(sireEpd.ribEyeArea_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.ribEyeArea_epd != null)  ? limitDecimal(sireEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.ribEyeArea_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (sireEpd && sireEpd.marbling_epd != null)  ? limitDecimal(sireEpd.marbling_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.marbling_epd != null)  ? limitDecimal(sireEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.marbling_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.fatThickness_epd != null)  ? limitDecimal(sireEpd.fatThickness_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.fatThickness_epd != null)  ? limitDecimal(sireEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.fatThickness_rank) : '-' }}</span>
                        </td>

                        <!--  -->
                        <td class="text-left" >
                            <span class="caption">{{ (sireEpd && sireEpd.carcass_weight_epd != null)  ? limitDecimal(sireEpd.carcass_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.carcass_weight_epd != null)  ? limitDecimal(sireEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.carcass_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.yield_grade_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.yield_grade_epd != null)  ? limitDecimal(sireEpd.yield_grade_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (sireEpd && sireEpd.milk_ability_epd != null)  ? limitDecimal(sireEpd.milk_ability_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.milk_ability_epd != null)  ? limitDecimal(sireEpd.milk_ability_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (sireEpd && sireEpd.milk_ability_epd != null)  ? limitDecimal(sireEpd.milk_ability_rank) : '-' }}</span>
                        </td>

                    <template v-for="(h, i) in headers">
                        <td class="text-left gray2" :key="h.value" v-if="i>9">
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                        </td>
                    </template>
                    

                    
                </tr>
                <tr
                  class=""
                >
                    <td >
                        <div class="py-3">
                            <div class="d-flex justify-space-between">
                                <span class="float-left font-weight-bold caption">Dam</span>
                                <span class="float-right font-weight-bold caption">EPD:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"> </span>
                                <span class="float-right font-weight-bold caption">+/-Chg:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption"></span>
                                <span class="float-right font-weight-bold caption">Accuracy:</span>
                            </div>
                            <div  class="d-flex justify-space-between">
                                <span class="float-left caption">% Ranked vs Active Dams</span>
                                <span class="float-right font-weight-bold caption">% Rank:</span>
                            </div>
                        </div>
                                        
                    </td>
                    <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.birth_weight_epd!=null) ? limitDecimal(damEpd.birth_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.birth_weight_epd!=null) ? limitDecimal(damEpd.birth_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.birth_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (damEpd && damEpd.weaning_weight_epd!=null) ? limitDecimal(damEpd.weaning_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.weaning_weight_epd!=null) ? limitDecimal(damEpd.weaning_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.weaning_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.yearling_weight_epd!=null) ? limitDecimal(damEpd.yearling_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yearling_weight_epd!=null) ? limitDecimal(damEpd.yearling_weight_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.yearling_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.ribEyeArea_epd!=null) ? limitDecimal(damEpd.ribEyeArea_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.ribEyeArea_epd!=null) ? limitDecimal(damEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.ribEyeArea_rank) : '-' }}</span>
                        </td>
                        <td class="text-left" >
                            <span class="caption">{{ (damEpd && damEpd.marbling_epd!=null) ? limitDecimal(damEpd.marbling_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.marbling_epd!=null) ? limitDecimal(damEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.marbling_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.fatThickness_epd!=null) ? limitDecimal(damEpd.fatThickness_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.fatThickness_epd!=null) ? limitDecimal(damEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.fatThickness_rank) : '-' }}</span>
                        </td>

                        <!--  -->
                        <td class="text-left" >
                            <span class="caption">{{ (damEpd && damEpd.carcass_weight_epd!=null) ? limitDecimal(damEpd.carcass_weight_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.carcass_weight_epd!=null) ? limitDecimal(damEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.carcass_weight_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.yield_grade_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.carcass_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.yield_grade_epd!=null) ? limitDecimal(damEpd.yield_grade_rank) : '-' }}</span>
                        </td>
                        <td class="text-left">
                            <span class="caption">{{ (damEpd && damEpd.milk_ability_epd!=null) ? limitDecimal(damEpd.milk_ability_epd) : '-' }}</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.milk_ability_epd!=null) ? limitDecimal(damEpd.milk_ability_accuracy) : '-' }}</span>
                            <br>
                            <span class="caption">{{ (damEpd && damEpd.milk_ability_epd!=null) ? limitDecimal(damEpd.milk_ability_rank) : '-' }}</span>
                        </td>
                    <template v-for="(h, i) in headers">
                        <td class="text-left gray2" :key="h.value" v-if="i>9">
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                            <br>
                            <span class="caption">-</span>
                        </td>
                    </template>
                </tr>
            </tbody>
        </template>
    </v-data-table>

        <!-- <div class="mt-5 title black--text py-2">Compiled Performance Statistics</div>
        <div class="mb-5 body-2 black--text">Expected Progeny Differences (EPDs) are driven by the progeny ratio's in multi-sire contemporary groups. The compiled performance should be used to help validate the epds of Black Herefords and their progeny .</div>
        <v-data-table
                :headers="headers2"
                :items="items"
                :items-per-page="10"
                hide-default-footer
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr>
                        <td class="br"></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class="br"><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                        <td class=""><div class="d-flex justify-space-between font-weight-bold"><span>C.E.Score </span><span>Ratio</span></div></td>
                  </tr>
                  <tr v-for="item in items" :key="item.value">
                        <td class="br font-weight-bold">Progeny of Z275 </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>12 </span><span>-</span></div> </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>25.5 </span><span>8</span></div> </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>25.5 </span><span>8</span></div> </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>25.5 </span><span>8</span></div> </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>25.5 </span><span>8</span></div> </td>
                        <td class="br"><div class="d-flex justify-space-between"><span>25.5 </span><span>8</span></div> </td>
                        <td ><div class="d-flex justify-space-between"><span>C.E.Score </span><span>Ratio</span></div></td>
                  </tr>
              </tbody>
            </template>
        </v-data-table> -->
    </div>
</template>

<script>
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";

export default {
    mounted() {
        this.startLoading()
        EPDService.getSingleEpdInfo(this.$route.params.geneticid, 'epd')
        .then(({data}) => {
            this.subjectEpd = data?.AnimalEpd || null
            this.sireEpd = data?.sires?.AnimalEpd || null
            this.damEpd = data?.dams?.AnimalEpd || null
        })
        .catch(e => {
            console.log('err', e)
        })
        .finally(() => {
            this.stopLoading()
        })
    },
    data() {
        return {
            items: [],
            subjectEpd: null,
            sireEpd: null,
            damEpd: null,
            headers: [
                {
                    text: this.$t(''),
                    align: "start",
                    class: "black--text",
                    width: '250px',
                    sortable: false,
                    headerTitle: '',
                    headerDef: '',
                },
                {
                    text: this.$t('BW'),
                    value: "bw",
                    class: "black--text",
                    align: 'start',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Birth Weight (BW): ',
                    headerDef: 'Compares the differences in the weight of calves at birth and is measured in pounds or kg.',
                },
                {
                    text: this.$t('WW'),
                    value: "ww",
                    class: "black--text",
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Weaning Weight (WW): ',
                    headerDef: 'WW EPD is an estimate of pre-weaning growth that is measured in pounds or kg.',
                },
                {
                    text: this.$t('YW'),
                    value: "yw",
                    class: "black--text",
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Yearling Weight (YW): ',
                    headerDef: 'YW EPD is an estimate of post-weaning growth that is measured in pounds or kg.',
                },
                {
                    text: this.$t('REA'),
                    value: "crea",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Ribeye Area (REA): ',
                    headerDef: 'REA measures the size of the muscle that gives us the ribeye in square inches.REA EPDs reflect differences in an adjusted 365-day ribeye area measurement based on carcass measurements of harvested cattle.',
                },
                {
                    text: this.$t('MARB'),
                    value: "marb",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '85px',
                    headerTitle: 'Marbling (MARB): ',
                    headerDef: 'The MARB EPD is in units of percentage of intramuscular fat within the ribeye.MARB EPDs reflect differences in an adjusted 365-day marbling score (intramuscular fat, [IMF]) based on carcass measurements of harvested cattle.',
                },
                {
                    text: this.$t('FAT'),
                    value: "fat",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Fat Thickness (FAT): ',
                    headerDef: 'Inches of backfat (in hundredths of an inch) is the unit of measurement for FT.',
                },
                {
                    text: this.$t('CW'),
                    value: "cw",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Carcass Weight (CW): ',
                    headerDef: 'Carcass weight is a beneficial trait when considering the impact that pounds have relative to end product value. At the same age constant endpoint, sires with higher values for carcass weight will add more pounds of hot carcass weight compared to sires with lower values for carcass weight.',
                },
                {
                    text: this.$t('YG'),
                    value: "yg",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Yield Grade (YG): ',
                    headerDef: 'The USDA Yield Grade scoring system is the unit of measurement for the YG EPD. Yield Grade 1 are leaner, more retail product carcasses.',
                },
                { 
                    text: this.$t('Milk'),
                    value: "milk",
                    class: "black--text",
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Milk (MK): ',
                    headerDef: 'The MK EPD is measured in pounds of calf weaning weight due to his mother’s milking ability.',
                },
                {
                    text: this.$t('TM'),
                    value: "tm",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '75px',
                    headerTitle: 'Total Maternal (TM): ',
                    headerDef: 'TM measures impact on calf weaning weight due to both milk production and the cow’s genetics for growth.',
                },
                { 
                    text: this.$t('CED'),
                    width: '75px', 
                    value: "ced",  
                    sortable: false,
                    align: 'center', 
                    class: "black--text px-0",
                    headerTitle: 'Calving Ease Direct (CED): ',
                    headerDef: 'The CED EPD is listed as a percentage of unassisted calvings.',
                },
                {
                    text: this.$t('CEM'),
                    value: "cem",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '77px',
                    headerTitle: 'Calving Ease Maternal (CEM): ',
                    headerDef: 'Measures the ability of a bull’s daughters to calves unassisted as two year olds.',
                },
                {
                    text: this.$t('STAY'),
                    value: "stay",
                    sortable: false,
                    align: 'start',
                    class: "black--text ",
                    width: '80px',
                    headerTitle: 'Stayability (STAY): ',
                    headerDef: 'The ST EPD predicts the ability of a bull to sire cows that “stay around”. The ST EPD is shown as a percentage of how much more likely a bull’s daughters will stay in your herd to the age of 6.',
                },
                {
                    text: this.$t('DOC'),
                    value: "doc",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                    width: '78px',
                    headerTitle: 'Docility (DOC): ',
                    headerDef: 'DOC measures the temperament of the cattle.',
                }
                // {
                //     text: this.$t('API'),
                //     value: "api",
                //     class: "black--text px-0",
                //     align: 'center',
                //     sortable: false,
                //     width: '5%',
                //     headerTitle: 'API',
                //     headerDef: '',
                // },
                // {
                //     text: this.$t('TI'),
                //     value: "ti",
                //     class: "black--text px-0",
                //     align: 'center',
                //     sortable: false,
                //     width: '5%',
                //     headerTitle: 'TI',
                //     headerDef: '',
                // },
            ],
            // headers2: [
            //     { text: this.$t('Pedigree Relationship'),width: '150px', divider:false, value: "milk", class: "black--text",  sortable: false },
            //     {
            //         text: this.$t('Calving Ease'),
            //         value: "tm",
            //         class: "black--text",
            //         align: 'center',
            //         sortable: false,
            //         divider:false,
            //         width: '150px'
            //     },
            //     { text: this.$t('Birth'),divider:false,width: '150px', value: "ced",  sortable: false,align: 'center', class: "black--text px-0" },
            //     {
            //         text: this.$t('Weaning'),
            //         value: "cem",
            //         class: "black--text px-0",
            //         align: 'center',
            //         sortable: false,
            //         divider:false,
            //         width: '150px'
            //     },
            //     {
            //         text: this.$t('Yearling'),
            //         value: "stay",
            //         sortable: false,
            //         align: 'start',
            //         class: "black--text ",
            //         divider:false,
            //         width: '150px'
            //     },
            //     {
            //         text: this.$t('US REA'),
            //         value: "doc",
            //         class: "black--text px-0",
            //         align: 'center',
            //         sortable: false,
            //         divider:false,
            //         width: '150px'
            //     },
            //     {
            //         text: this.$t('US IMF'),
            //         value: "cw",
            //         class: "black--text px-0",
            //         align: 'center',
            //         sortable: false,
            //         divider:false,
            //         width: '150px'
            //     },
            //     {
            //         text: this.$t('US F.T.'),
            //         value: "yg",
            //         class: "black--text px-0",
            //         align: 'center',
            //         sortable: false,
            //         divider:false,
            //         width: '150px'
            //     },
            // ],
        }
    },
    mixins: [loadingMixin, generalMixin]
}
</script>

<style>
.br {
    border-right: 1px solid #00000033;
}
</style>